TypeaheadController.$inject = ['$scope'];

export function TypeaheadController(scope) {
    scope.typeaheadLabel = function (value, collection) {
        if (value && collection) {
            return collection.filter(function (item) {
                return item.value === value;
            })[0].label;
        }
    };
}
